import { createType } from 'framework/utils/createType';

export const AgeRestrictions = createType('<18', '>18', '>18&<65', '>65');
export type AgeRestriction = typeof AgeRestrictions[number];
